<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <div class="mbl text-center">
    <span>Répartition par : </span>
    <pr-radio
      [defaultValue]="supportRepartitionType"
      [choices]="[
        ['PERCENTAGE', 'Pourcentage', true, false],
        ['AMOUNT', 'Montant', true, this.isSwisslifeProduct],
      ]"
      (onSelectChoice)="toggleColumnType($event)"
    >
    </pr-radio>
  </div>
  <form-wrapper>
    @if (products.length) {
      <div class="row">
        @if (showInitialTable) {
          <div [class]="tableColumnClass">
            <supports-table
              [supports]="supportRepartition"
              [config]="initialTable"
              (removeSupport)="deleteFields($event.index)"
            ></supports-table>
            <pr-color-panel [display]="allocationPanelAvInitial?.display">
              <pr-panel-body clazz="pam">
                <pr-label
                  [name]="allocationPanelAvInitial?.icon"
                  [width]="18"
                  [height]="18"
                  >{{ allocationPanelAvInitial?.text }}</pr-label
                >
              </pr-panel-body>
            </pr-color-panel>
            <pr-color-panel [display]="riskNoteInitial?.display">
              <pr-panel-body clazz="pam">
                <pr-label
                  [name]="riskNoteInitial?.icon"
                  [width]="18"
                  [height]="18"
                  >{{ riskNoteInitial?.text }}</pr-label
                >
              </pr-panel-body>
            </pr-color-panel>
          </div>
        }
        @if (showMonthlyTable) {
          <div [class]="tableColumnClass">
            <supports-table
              [supports]="supportRepartition"
              [config]="monthlyTable"
              (removeSupport)="deleteFields($event.index)"
            ></supports-table>
            <pr-color-panel [display]="allocationPanelAvMonthly?.display">
              <pr-panel-body clazz="pam">
                <pr-label
                  [name]="allocationPanelAvMonthly?.icon"
                  [width]="18"
                  [height]="18"
                  >{{ allocationPanelAvMonthly?.text }}</pr-label
                >
              </pr-panel-body>
            </pr-color-panel>
            <pr-color-panel [display]="riskNoteMonthly?.display">
              <pr-panel-body clazz="pam">
                <pr-label
                  [name]="riskNoteMonthly?.icon"
                  [width]="18"
                  [height]="18"
                  >{{ riskNoteMonthly?.text }}</pr-label
                >
              </pr-panel-body>
            </pr-color-panel>
          </div>
        }
      </div>
    }

    @if (!pledge.products[0].parameters.productPackId) {
      <div class="row d-flex">
        <div class="col-xs-12 col-sm-12 col-md-12">
          <div class="btn-group">
            <pr-button
              size="lg"
              type="button"
              label="Ajouter un nouveau support"
              icon="add"
              (onClick)="prev()"
            ></pr-button>
          </div>
        </div>
      </div>
    }
  </form-wrapper>

  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
